<script>
import Vue from 'vue';
import {mapState} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            bankInfo: state => state.contract.contract.item.supplierInfo.bankInfo,
            bookingInfo: state => state.contract.contract.item.supplierInfo.bookingInfo,
            contactInfo: state => state.contract.contract.item.supplierInfo.contactInfo
        }),
    },
});
</script>
<template>
    <div class="contract-form-supplier-info">
        <div class="contract-form-supplier-info__header">
            <div class="contract-form-supplier-info__heading">
                {{ $t('contract.form.accommodations.header.heading') }}
            </div>
        </div>
        <div class="contract-form-supplier-info__body">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="contract-form-supplier-info__container">
                        <div class="contract-form-supplier-info__content-heading">
                            {{ $t('contract.form.supplierInfo.bookingInfo.heading') }}
                        </div>
                        <div class="contract-form-supplier-info__content contract-form-supplier-info__content--booking">
                            <div v-for="(info, key) in bookingInfo"
                                 :key="key"
                                 class="contract-form-supplier-info__item contract-form-supplier-info__item--booking">
                                <div :class="{'contract-form-supplier-info__item-label--inactive': !info}" class="contract-form-supplier-info__item-label">
                                    {{ $t('contract.form.supplierInfo.bookingInfo.' + key) }}:
                                </div>
                                <div class="contract-form-supplier-info__item-value">
                                    {{ info }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="contract-form-supplier-info__container">
                        <div class="contract-form-supplier-info__content-heading">
                            {{ $t('contract.form.supplierInfo.contactInfo.heading') }}
                        </div>
                        <div class="contract-form-supplier-info__content">
                            <div v-for="(info, key) in contactInfo" :key="key" class="contract-form-supplier-info__item">
                                <div :class="{'contract-form-supplier-info__item-label--inactive': !info}" class="contract-form-supplier-info__item-label">
                                    {{ $t('contract.form.supplierInfo.contactInfo.' + key) }}:
                                </div>
                                <div class="contract-form-supplier-info__item-value">
                                    {{ info }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="contract-form-supplier-info__container">
                        <div class="contract-form-supplier-info__content-heading">
                            {{ $t('contract.form.supplierInfo.bankInfo.heading') }}
                        </div>
                        <div class="contract-form-supplier-info__content">
                            <div v-for="(info, key) in bankInfo" :key="key" class="contract-form-supplier-info__item">
                                <div :class="{'contract-form-supplier-info__item-label--inactive': !info}" class="contract-form-supplier-info__item-label">
                                    {{ $t('contract.form.supplierInfo.bankInfo.' + key) }}:
                                </div>
                                <div class="contract-form-supplier-info__item-value">
                                    {{ info }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormSupplierInfo/ContractFormSupplierInfo.vue